
import moment from "moment-timezone";

export default [
    {
        "uid": 300500,
        "status": "Paid",
        "name": "Platinum Subscription Plan",
        "nameofapplications": "799,00",
        "type": moment().subtract(1, "days").format("DD MMM YYYY"),
        "email": moment().subtract(1, "days").add(1, "month").format("DD MMM YYYY")
    }
   
]